
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getExchangeRateList } from '@/api/merchant/fund'
import { getSubordinateAgencyList } from '@/api/merchant/agentProduct'

@Component
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string
  @Prop({ required: false, default: false }) openRateDialog!: boolean
  private listLoading: boolean = false
  private loading: boolean = false
  private exchangeRateList: any[] = []
  private queryForm: any = {
    merchant_no: '',
    name: ''
  }
  private quoteCurrencyTypes: any[] = []
  private total = 0

  private subFeeVisible: boolean = false
  private subInfo: any = []

  private openSubDialog(row: any) {
    this.subFeeVisible = true
    this.subInfo = row
  }

  private closeSubFee() {
    this.subFeeVisible = false
  }

  private async getList() {
    this.listLoading = true
    try {
      await getSubordinateAgencyList({
        merchant_no: this.merchant_no,
        body: {
          ...this.queryForm,
          page_size: this.pagesize,
          page: this.currentPage
        }
      }).then((res: any) => {
        this.exchangeRateList = res.results
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.getList()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.getList()
  }

  private reset() {
    this.queryForm = {
      merchant_no: '',
      name: ''
    }
    // this.currentPage = 1
    this.$nextTick(() => {
      this.getList()
    })
  }

  private select() {
    // this.currentPage = 1
    this.getList()
  }

  mounted() {
    this.getList()
  }
}
